// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"iJ-z","smallCardRow":"jJ-z","largeCardRow":"kJ-z","productSearchRow":"lJ-z","curatedRow":"mJ-z"};